/**
 * Chapter012.js — Consultation & Communication (OHSE 012)
 * Migrated from SWMS Platform Chapter012.tsx → JavaScript
 *
 * Static policy text only — company name is the only variable.
 *
 * Props:
 *   companyName {string}  from companyInfo.name
 */

const CONSULTATION_SUBJECTS = [
  'Hazard identification and risk assessment processes',
  'Control measures for the management of hazards and risks',
  "Changes to the organisation's policies and procedures or work routines which may affect OHSE",
  'Make up of and representation on relevant committees',
  'Election of OHSE and employee representatives',
];

export default function Chapter012({ companyName }) {
  const cn = companyName || '[Company Name]';
  const Co = () => <span className="font-semibold text-[#c9a84c]">{cn}</span>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">OHSE 012</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">
          Consultation &amp; Communication
        </h2>
      </div>

      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <div className="px-4 py-2.5 bg-[#f0ede6]">
          <h3 className="text-sm font-semibold text-[#1a1a2e] uppercase tracking-wide">
            Consultation &amp; Communication
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Active participation of all employees in OHSE decisions
          </p>
        </div>
        <div className="p-6 space-y-4 text-sm text-[#1a1a2e] leading-relaxed">
          <p>
            <Co /> promotes the active participation of all employees in OHSE decisions.
          </p>
          <p>
            Employees are consulted and given opportunity, encouragement and training to be
            proactively involved in OHSE matters affecting the organisation and their work activities.
          </p>
          <p>
            Consultation occurs in reference to, but not limited to, the following subjects / topics:
          </p>
          <ul className="space-y-1.5 ml-1">
            {CONSULTATION_SUBJECTS.map((subject, idx) => (
              <li key={idx} className="flex items-start gap-2.5">
                <span className="mt-2 w-1 h-1 rounded-full bg-[#c9a84c] shrink-0" />
                <span>{subject}</span>
              </li>
            ))}
          </ul>
          <p>All workplace consultation is recorded and occurs on a 3 months basis.</p>
        </div>
      </div>
    </div>
  );
}
